module.exports = require('./bundle').codeFrame()
